const DEFAULT_MAX_LENGTH = 9999
const MAX_NOTIFICATION_LENGTH = 300

export const getDefaultMaxLength = (maxLength) => maxLength ?? DEFAULT_MAX_LENGTH

export const checkIsSuitable = (length) => length > MAX_NOTIFICATION_LENGTH ? false : true